import { styled, Box, Typography, Button, Grid } from '@mui/material';
import {
  Business as BusinessIcon,
  CheckCircle as CheckCircleIcon,
  InfoOutlined as InfoOutlinedIcon,
} from '@mui/icons-material';

export const SummaryContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
});

export const ScrollableContent = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingTop: '2px',
  paddingBottom: '16px',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#c1c1c1',
    borderRadius: '3px',
  },
});

export const LoadingBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '400px',
});

export const LoadingText = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#75838A',
});

export const NoDataBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '400px',
  gap: '16px',
});

export const NoDataTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '18px',
  color: '#0B2330',
  fontWeight: 500,
});

export const NoDataText = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  color: '#75838A',
});

export const TopRowWrapper = styled(Box)({
  display: 'flex',
  gap: '20px',
  width: '100%',
  overflow: 'hidden',
});

export const LeftColumn = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '19px',
});

export const SectionTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#0B2330',
});

export const RowBetween = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
});

export const ColumnGap8 = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const ColumnGap8Right = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'flex-end',
});

export const DateBlockContainer = styled(Grid)({
  backgroundColor: '#FAFAFA',
  borderRadius: '8px',
  padding: '12px',
  width: '100%',
});

export const DateBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
});

export const AddressCard = styled(Box)({
  width: '200px',
  height: '126px',
  border: '1px solid #DFDFDF',
  borderRadius: '8px',
  position: 'relative',
  padding: '11px 12px',
});

export const AddressTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '12px',
  color: '#75838A',
  marginBottom: '10px',
});

export const AddressRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '6px',
});

export const AddressName = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '12px',
  color: '#003572',
});

export const AddressLine = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '12px',
  color: '#0B2330',
  letterSpacing: '0.5px',
});

export const AddressLinesWrap = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const AddressesWrap = styled(Box)({
  display: 'flex',
  gap: '17px',
});

export const ItemsTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#0B2330',
  marginTop: '5px',
});

export const ItemsContainer = styled(Grid)({
  width: '100%',
  marginBottom: '16px',
  border: '1px solid #D9F1FF',
  borderRadius: '8px',
  overflow: 'hidden',
  background: '#fff',
  padding: '8px',
});

export const ItemsListContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const ItemsScrollWrapper = styled(Box)({
  maxHeight: '240px',
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#c1c1c1',
    borderRadius: '3px',
  },
});

export const ItemsHeader = styled(Box)({
  display: 'flex',
  fontWeight: 500,
  fontSize: '14px',
  color: '#75838A',
  fontFamily: 'Outfit',
  marginBottom: '8px',
});

export const ItemRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  fontFamily: 'Outfit',
  fontSize: '14px',
  color: '#0B2330',
  paddingTop: '4px',
  paddingBottom: '4px',
});

export const ItemCell2 = styled(Box)({
  flex: 2,
});

export const ItemCell1Right = styled(Box)({
  flex: 1,
  textAlign: 'right',
});

export const SmallLabel14 = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  color: '#75838A',
});

export const SmallLabel14Right = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  color: '#75838A',
  textAlign: 'right',
});

export const SmallValue14 = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  color: '#0B2330',
});

export const StyledBusinessIcon = styled(BusinessIcon)({
  fontSize: '16px',
  color: '#003572',
});

export const StyledCheckCircleIcon = styled(CheckCircleIcon)({
  fontSize: '20px',
  color: '#0F52BA',
});

export const RightColumn = styled(Box)({
  width: '400px',
  flexShrink: 0,
  backgroundColor: '#FAFAFA',
  borderRadius: '8px',
  padding: '24px 12px 12px 12px',
  display: 'flex',
  flexDirection: 'column',
});

export const DiscountsHeaderWrap = styled(Box)({
  marginBottom: '41.49px',
});

export const DiscountsRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '9.81px',
});

export const DiscountAppliedRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const DiscountText = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#75838A',
});

export const DiscountAmountLabel = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#0B2330',
  textAlign: 'right',
});

export const SurchargesBlock = styled(Box)({
  marginBottom: '37.32px',
});

export const SurchargesTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#75838A',
  marginBottom: '8px',
});

export const SurchargeRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '6px',
});

export const SurchargeText = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#0B2330',
});

export const SurchargeValue = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#0B2330',
  textAlign: 'right',
});

export const FinalTotalsHeading = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#75838A',
  marginBottom: '19.63px',
});

export const TotalsRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '21.64px',
});

export const TotalsRowMb2373 = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '23.73px',
});

export const TotalsLabel = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#0B2330',
});

export const TotalsValueCombined = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#0B2330',
  textAlign: 'right',
});

export const DiscountLabelRed = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#e85e51',
});

export const SurchargeLabelBlue = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#0F52BA',
});

export const SurchargesValue = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  color: '#0F52BA',
  textAlign: 'right',
});

export const GrandTotalBox = styled(Box)({
  height: '60px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #D9F1FF',
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: '11.67px',
  paddingRight: '11.67px',
});

export const ActionsWrap = styled(Box)({
  flexShrink: 0,
  paddingTop: '16px',
  backgroundColor: '#FFFFFF',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
});

export const BackButton = styled(Button)({
  width: '82px',
  height: '40px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #D9D9D9',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px #E2E3E1',
  fontFamily: 'Outfit',
  fontWeight: 500,
  fontSize: '16px',
  color: '#0B2330',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
});

export const SaveButton = styled(Button)({
  width: '83px',
  height: '40px',
  backgroundColor: '#0F52BA',
  border: '1px solid #0D4AA9',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px #E2E3E1',
  fontFamily: 'Outfit',
  fontWeight: 500,
  fontSize: '16px',
  color: '#FFFFFF',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#0D4AA9',
  },
});

export const SaveCompleteButton = styled(Button)({
  width: '186px',
  height: '40px',
  backgroundColor: '#0F52BA',
  border: '1px solid #0D4AA9',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px #E2E3E1',
  fontFamily: 'Outfit',
  fontWeight: 500,
  fontSize: '16px',
  color: '#FFFFFF',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#0D4AA9',
  },
});

export const TooltipContainer = styled(Box)({
  padding: '12px',
  minWidth: '200px',
});

export const TooltipTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 600,
  color: '#FFFFFF',
  marginBottom: '12px',
  borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
  paddingBottom: '8px',
});

export const TooltipRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '8px',
  gap: '16px',
});

export const TooltipLabel = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '13px',
  color: 'rgba(255, 255, 255, 0.9)',
});

export const TooltipValue = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '13px',
  color: '#FFFFFF',
  fontWeight: 500,
});

export const TooltipTotalRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '8px',
  paddingTop: '8px',
  borderTop: '1px solid rgba(255, 255, 255, 0.2)',
  gap: '16px',
});

export const TooltipTotalLabel = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '13px',
  fontWeight: 600,
  color: '#FFFFFF',
});

export const TooltipTotalValue = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '13px',
  fontWeight: 600,
  color: '#FFFFFF',
});

export const InfoIconStyled = styled(InfoOutlinedIcon)({
  fontSize: '16px',
  color: '#75838A',
  marginLeft: '6px',
  cursor: 'pointer',
  verticalAlign: 'middle',
  '&:hover': {
    color: '#0F52BA',
  },
});

export const InfoIconBlue = styled(InfoOutlinedIcon)({
  fontSize: '16px',
  color: '#75838A',
  marginLeft: '6px',
  cursor: 'pointer',
  verticalAlign: 'middle',
  '&:hover': {
    color: '#0F52BA',
  },
});

export const LabelWithIcon = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});
